//utils
import { combineReducers } from 'redux';
// reducers
import homeView from './home/home-dux';

// combineReducers for views exists mainly for organization purposes in global app state tree
export default combineReducers( {
	homeView
} );



// WEBPACK FOOTER //
// ./src/views/views-dux.js